import React from 'react'
import { Link } from 'react-router-dom'

export default function Copyright() {
  return (
    <div className="copyright">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <p className="p-small">
            Copyright © {(new Date().getFullYear())} FalconEye AI Solutions. All rights reserved.<br />
            <Link to="/terms" className="white">Terms of Service</Link> | <Link to="/privacy" className="white">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </div>
  </div> 
  )
}
